import { Grid, Table, TableBody, TableCell, TableHead, TableRow, Button } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AppRootState } from '../../app/store';
import { checkAutoLogin, getUserData } from '../Login/auth-reducer';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { AccountType, getAccountsTC } from './accounts-reducer';
import { AccountItem } from './AccountItem';
import { setCurrentLocation } from '../../app/cookies';
import { fetchProjectsTC } from '../Projects/project-reducer';

export const AccountsList = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isLoggedIn = useSelector<AppRootState, boolean>(state => state.auth.isLoggedIn)
  const accounts = useSelector<AppRootState, Array<AccountType>>(state => state.accounts.accounts)
  

  useEffect(() => {
    let token = checkAutoLogin(dispatch,true)
    if (token === null && isLoggedIn === false) {
      return navigate('/login')
    }
    dispatch(fetchProjectsTC(token))
    dispatch(getUserData())
    setCurrentLocation(`\\ Accounts `)
    dispatch(getAccountsTC())
  }, [isLoggedIn])

  return (
    <>
      <Grid container style={{ paddingTop: '70px', paddingBottom: '50px' }} spacing={3} alignItems="center">
        <Grid item xl={6} md={6} xs={6} style={{ paddingTop: '30px' }}>
             <Button onClick={(e) => navigate(`/`)} color='info' className='addItemButton' startIcon={<KeyboardReturnIcon style={{ color: 'grey' }} fontSize='medium' />}>
            Back to projects
          </Button>
        </Grid>
        <Grid item xl={6} md={6} xs={6} onClick={() => {
          setCurrentLocation(`\\ Accounts \\ New Account `)
         navigate(`/accountsList/newAccount`)
        }} >
          <Button className='addItemButton'  style={{ float: 'right', color:'#00a0d1' }} startIcon={<PersonAddIcon style={{ color: 'grey' }} fontSize='medium' />}>
            Add new Account
          </Button>
        </Grid>
      </Grid>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{ textAlign: 'center' }}>
              #ID
            </TableCell>
            <TableCell >
              Name
            </TableCell>
            <TableCell style={{ textAlign: 'center', minWidth: '75px' }}>
              E-mail
              <span style={{ cursor: 'pointer', marginLeft: '5px' }}></span>
            </TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              Count of Users
            </TableCell>
            <TableCell style={{ textAlign: 'center', minWidth: '154px' }}>
              Status
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {accounts.map((account) => (
            <AccountItem key={account.id} account={account} />
          ))}
        </TableBody>
      </Table>
    </>
  )
}
